import { render, staticRenderFns } from "./CaseNotesCard.vue?vue&type=template&id=c7118a3a"
import script from "./CaseNotesCard.vue?vue&type=script&lang=js"
export * from "./CaseNotesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports